import http from "@/utils/request"

export default {
	trade: {
		list: async function (data = {}) {
			return await http.get("trade/list", data);
		},
		info: async function (data = {}) {
			return await http.get("trade/info", data);
		},
		refund: async function (data = {}) {
			return await http.post("trade/refund", data);
		},
	},
	trade_refund: {
		list: async function (data = {}) {
			return await http.get("trade/refund/list", data);
		},
		info: async function (data = {}) {
			return await http.get("trade/refund/info", data);
		},
	},
	division: {
		list: async function (data = {}) {
			return await http.get("division/list", data);
		},
		info: async function (data = {}) {
			return await http.get("division/info", data);
		},
	},
	division_refund: {
		list: async function (data = {}) {
			return await http.get("division/refund/list", data);
		},
		info: async function (data = {}) {
			return await http.get("division/refund/info", data);
		},
	},
	statistics: {
		list: async function (data = {}) {
			return await http.get("trade/statistics", data);
		},
	}
}
